import type { TweetResponseContent } from './tweetResponseContent';
import type { TweetResponseMediaItem } from './tweetResponseMediaItem';
import type { TweetResponsePoll } from './tweetResponsePoll';
import type { TweetResponseStats } from './tweetResponseStats';
import type { TweetResponseTags } from './tweetResponseTags';
import type { TweetResponseTweetType } from './tweetResponseTweetType';

export interface TweetResponse {
  authorDisplayName?: string;
  authorId?: string;
  authorProfileImageUrl?: string;
  authorUsername?: string;
  content?: TweetResponseContent;
  createdAt?: string;
  isLiked?: boolean;
  isRetweeted?: boolean;
  media?: TweetResponseMediaItem[];
  poll?: TweetResponsePoll;
  /**
   * ID of the referenced tweet (for replies and quotes)
   * @nullable
   */
  referencedTweetId?: string | null;
  stats?: TweetResponseStats;
  tags?: TweetResponseTags;
  tweetId?: string;
  /** Type of tweet */
  tweetType?: TweetResponseTweetType;
  updatedAt?: string;
}
